<template>
  <Enroll :path="'/continueEdu'"></Enroll>
</template>

<script>
  import Enroll from '@/page/modules/enroll/detail'
  export default {
    components: { Enroll },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
  .online_bg { margin-top: 0; }
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/enroll/detail.vue